import Countdown from '@components/components/Countdown/Countdown';
import React from 'react';

const CmsCountdown = ({
  ctas,
  date,
  isMinimal,
  title,
  subtitle,
  hasBadge,
  badgeVariant,
  badgeText,
  location,
  showLocation,
  showEnddate,
  image,
  expiredImage,
  expiredTitle,
  expiredSubtitle,
  expiredLink,
}) => {
  const timestamp = Date.parse(date?.date?.replace(' ', 'T')) || 0;
  return (
    <div>
      <Countdown
        badgeText={badgeText}
        badgeVariant={badgeVariant}
        ctas={ctas}
        expiredImage={expiredImage}
        expiredLink={expiredLink}
        expiredSubtitle={expiredSubtitle}
        expiredTitle={expiredTitle}
        hasBadge={hasBadge}
        image={image}
        isMinimal={isMinimal}
        location={location}
        showEnddate={showEnddate}
        showLocation={showLocation}
        subtitle={subtitle}
        timestamp={timestamp}
        title={title}
      />
    </div>
  );
};

export default CmsCountdown;
